export const getDateRange = (year: number) => {
  return {
    start: new Date(`${year}-01-01T00:00:00.000-0500`),
    end: new Date(`${year}-12-31T23:59:59.999-0500`),
  }
}
